// extracted by mini-css-extract-plugin
export default {"profile-relation":"Badge_profile-relation__IWLo9","beige":"Badge_beige__x8V3l","green":"Badge_green__MUeL3","blue":"Badge_blue__miLUk","purple":"Badge_purple__jeyV4"};